import Filter from 'modules/core/components/Filter'
import i18n from 'modules/core/lib/i18n'

import { useFilter } from '../context'

interface Props {
  materializedTargetIds?: number[]
}

export const EmployeeFilter = ({ materializedTargetIds }: Props) => {
  const { value, setValue } = useFilter('employees')

  return (
    <Filter.EmployeeSelector
      label={i18n.t('common.employee')}
      nameAttribute="fullName"
      value={value}
      onValueChange={(employees) => setValue(employees ?? [])}
      employeeIds={materializedTargetIds}
    />
  )
}
